import { TIENDA, MENSAJE_COMPRA } from "../data/config";
import { useWhatsApp } from "../hooks/useWhatsApp";
import IconoWhatsApp from "./ui/IconoWhatsApp";

const ENLACES = [
  { href: "#producto", texto: "Producto" },
  { href: "#beneficios", texto: "Beneficios" },
  { href: "#testimonios", texto: "Reseñas" },
  { href: "#nosotros", texto: "Nosotros" },
  { href: "#contacto", texto: "Contacto" },
];

const Footer = () => {
  const { abrirWhatsApp } = useWhatsApp();
  const anio = new Date().getFullYear();

  return (
    <footer className="bg-ink text-white">
      <div className="mx-auto max-w-container px-5 py-20 md:px-16">
        <div className="grid gap-12 md:grid-cols-3">
          {/* Marca */}
          <div>
            <p className="font-literata text-2xl font-bold text-white">
              {TIENDA.nombre}
            </p>
            <p className="mt-3 max-w-xs text-base text-white/60">
              Mantequilla de maní 100% natural, hecha con cariño en{" "}
              {TIENDA.ciudad}.
            </p>
          </div>

          {/* Navegación */}
          <nav aria-label="Enlaces del sitio">
            <p className="text-xs font-semibold uppercase tracking-label text-white/50">
              Explora
            </p>
            <ul className="mt-4 space-y-3">
              {ENLACES.map((enlace) => (
                <li key={enlace.href}>
                  <a
                    href={enlace.href}
                    className="text-base text-white/80 transition-colors hover:text-gold"
                  >
                    {enlace.texto}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contacto */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-label text-white/50">
              Contacto
            </p>
            <ul className="mt-4 space-y-3 text-base text-white/80">
              <li>{TIENDA.whatsapp}</li>
              <li>
                <a
                  href={TIENDA.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-gold"
                >
                  @{TIENDA.instagram}
                </a>
              </li>
              <li>{TIENDA.ciudad}</li>
              <li className="text-white/60">{TIENDA.horario}</li>
            </ul>

            <button
              type="button"
              onClick={() => abrirWhatsApp(MENSAJE_COMPRA)}
              className="mt-6 inline-flex items-center gap-3 rounded-xl bg-forest px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-forest/90"
            >
              <IconoWhatsApp className="text-xl" />
              Comprar ahora
            </button>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8 text-center text-sm text-white/50">
          © {anio} {TIENDA.nombre}. Todos los derechos reservados. ·{" "}
          {TIENDA.precioFormateado} el frasco de {TIENDA.peso}.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
